import IndexTableRow from '../index-table/IndexTableRow'
import ProjectsIndexTableRowRenderer from '../projects/ProjectsIndexTableRowRenderer'
import CopyQuoteOrderProductionOrderIInformationModal
    from '../project/modals/CopyQuoteOrderProductionOrderIInformationModal';
import Assets from '@lib/Assets';
import ProjectHelper from '../project/ProjectHelper';
import * as React from 'react';

export default class ProjectIndexTableRow extends IndexTableRow {

    constructor(props) {
        super(props);
        this.state.copyQuoteOrderProductionOrderInformationModalVisible = false;
    }

    loadRowRenderer() {
        this.rowRenderer = new ProjectsIndexTableRowRenderer(this.props, this);
    }

    renderCopyButtonAction = (button, row, editAPIService, buttonIndex) => {
        if (!this.props.row.canCopy) {
            return (
                <React.Fragment/>
            )
        }

        if (ProjectHelper.isQuoteOrOrderOrProduction(this.props.row.type)) {
            return (
                <React.Fragment>
                    <a className="index-action-button"
                       onClick={() => this.setState({copyQuoteOrderProductionOrderInformationModalVisible: true})}><img
                        src={Assets[button.icon]}/></a>
                    {ProjectHelper.isQuoteOrOrderOrProduction(this.props.row.type) &&
                        <CopyQuoteOrderProductionOrderIInformationModal
                            isOpen={this.state.copyQuoteOrderProductionOrderInformationModalVisible}
                            onCancelClick={() => this.setState({copyQuoteOrderProductionOrderInformationModalVisible: false})}
                            onYesClick={() => editAPIService.copyAndEdit(this.props.row.id)}
                            name={this.props.row.name}
                            status={this.props.row.type}
                        />}
                </React.Fragment>
            )
        }

        return (
            <a className="index-action-button" onClick={() => this.onCopyClick(editAPIService)}><img
                src={Assets[button.icon]}/></a>
        )
    }


    onCopyClick = (editAPIService) => {
        editAPIService.copyAndEdit(this.props.row.id);
    }
}